import React, { useState, MouseEvent } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { IconDotsVertical, IconPencil, IconPin, IconPinFilled } from '@tabler/icons-react';
import { isAuthorized } from 'src/utils/authorization';

interface Product {
    _id: string;
    itemName: string;
    itemUrl?: string;
    sellingPrice: number;
    colorCode?: string;
    pinned?: boolean;
    type?: string;
    itemCode?: string;
    isActive:boolean;
}

interface SelectedService {
    _id: string;
    itemName: string;
    sellingPrice: number;
}

interface ProductCardProps {
    product: Product;
    categoryImageUrl: string;
    handleEditService: (service: SelectedService) => void;
    setEditServiceModal: (open: boolean) => void;
    onItemClick: (product: Product) => void;
    handleAction: (product: Product) => void;
    handleEditGiftCard: (giftCard: any) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, categoryImageUrl, onItemClick, handleAction, setEditServiceModal, handleEditService, handleEditGiftCard }) => {

    // console.log('------product', product)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenuClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const [imageError, setImageError] = useState(false);

    // const imageSrc =
    //     !imageError
    //         ? product?.itemUrl
    //             ? `${process.env.REACT_APP_BASE_URL}/${product.itemUrl}`
    //             : categoryImageUrl
    //                 ? `${process.env.REACT_APP_BASE_URL}/${categoryImageUrl}`
    //                 : ""
    //         : "";

    const imageSrc =
        product?.type === "SERVICE_GIFTCARD"
            ? "/giftcard.jpeg"
            : !imageError
                ? product?.itemUrl
                    ? `${process.env.REACT_APP_BASE_URL}/${product.itemUrl}`
                    : categoryImageUrl
                        ? `${process.env.REACT_APP_BASE_URL}/${categoryImageUrl}`
                        : ""
                : "";

    const handleClose = () => setAnchorEl(null);

    const handlePinToggle = (event: MouseEvent<HTMLLIElement>) => {
        event.stopPropagation(); // prevent card click
        handleAction(product);
        handleClose();
    };

   const handleEditServiceModalOpen = () => {
  handleClose();

  if (product.type === 'SERVICE_GIFTCARD') {
    handleEditGiftCard(product);
  } else {
    handleEditService(product);
  }

  setEditServiceModal(true);
};

    return (
       <div
  key={product._id}
  className={`w-[170px] h-[219px] rounded-lg overflow-hidden border transition relative bg-white ${
    product.isActive === false
      ? 'opacity-60 grayscale'
      : 'hover:shadow-md cursor-pointer'
  }`}
  onClick={() => {
    if (product.isActive === false) return;

    const price = product?.sellingPrice ?? 0;
    if (price > 0) {
      onItemClick(product);
    }
  }}
  style={{
    borderColor: product.pinned ? '#006972' : (product.colorCode || '#ccc'),
    borderWidth: '2px',
    borderStyle: 'solid',
  }}
>

        
            {/* Image */}
            <div className="w-full h-[110px] bg-gray-100 relative">
                {/* <img
                    src={
                        product.itemUrl 
                            ? `${process.env.REACT_APP_BASE_URL}/${product.itemUrl}`
                            : `${process.env.REACT_APP_BASE_URL}/${categoryImageUrl}` || '/no-image.jpg'
                    }
                    alt={product.itemName}
                    className="w-full h-full object-cover"
                /> */}
                <div
                    className="w-full h-[110px] bg-gray-100 relative flex items-center justify-center"
                    style={{
                        backgroundColor: product?.colorCode || "#e5e7eb",
                    }}
                >
                    {imageSrc ? (
                        <img
                            src={imageSrc}
                            alt={product?.itemName || ""}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                                setImageError(true);
                            }}
                        />
                    ) : null}

        {product.isActive === false && (
    <div className="absolute top-0 left-0 z-[5] overflow-hidden w-[100px] h-[100px] pointer-events-none">
        <div
            className="absolute top-[18px] left-[-29px] w-[115px] -rotate-45
                       bg-slate-700/90 text-white text-[10px] font-bold
                       tracking-wider text-center py-[5px]
                       shadow-md border-y border-white/20"
        >
            INACTIVE
        </div>
    </div>
)}

                    {/* 3-dot Menu */}
                    {/* <div
    className="absolute top-1 right-1 p-[6px] z-10"
    onClick={handleMenuClick}
  >
    <IconDotsVertical size={16} color="#006972" />
  </div> */}
                </div>

                {/* 3-dot Menu */}


                {/* Dropdown Menu */}
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    onClick={(e) => e.stopPropagation()}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                
                >
                    <MenuItem
                        onClick={handlePinToggle}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1, // spacing between icon and text
                            fontSize: '0.875rem', // small text (14px)
                            paddingY: 1,
                            paddingX: 2,
                        }}
                    >
                        {product.pinned ? (
                            <>
                                <IconPinFilled size={16} />
                                <span style={{ fontSize: '0.875rem' }}>Unpin</span>
                            </>
                        ) : (
                            <>
                                <IconPin size={16} />
                                <span style={{ fontSize: '0.875rem' }}>Pin</span>
                            </>
                        )}
                    </MenuItem>
                    {isAuthorized("EDIT_SERVICE_ON_POS") && (<MenuItem onClick={handleEditServiceModalOpen} sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1, // spacing between icon and text
                        fontSize: '0.875rem', // small text (14px)
                        paddingY: 1,
                        paddingX: 2,
                    }}> <>
                            <IconPencil size={16} />
                            <span style={{ fontSize: '0.875rem' }}>Edit</span>
                        </></MenuItem>)}

                </Menu>
            </div>

            {/* Item Name */}
            {/* <div className="p-2 text-[14px] font-medium text-gray-800 line-clamp-2 min-h-[59px]">
                {product.itemName}
            </div> */}
            <div className="p-2 text-[14px] font-medium text-gray-800 min-h-[59px]">
                {product.itemName
                    ? product.itemName
                        .split(" ")
                        .map(
                            (word) =>
                                word?.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")
                        .slice(0, 40) + (product.itemName.length > 40 ? "..." : "")
                    : ""}

                {product.itemCode && (
                    <div className="text-[12px] text-gray-500 font-normal mt-1">
                        {product.itemCode}
                    </div>
                )}
            </div>


            {/* Price Row */}
            <div className="absolute bottom-0 left-0 w-full px-2 pb-1 text-sm font-semibold text-primary">
                R {product.sellingPrice}
            </div>

            <div
                className="absolute bottom-1 right-0 p-[6px] z-10"
                onClick={(e) => {
                    e.stopPropagation();
                    handleMenuClick(e);
                }}
            >
                <IconDotsVertical size={21} color="#006972" />
            </div>
        </div>
    );
};

export default ProductCard;
